import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { chemistryData } from '../../data/departmentalData/chemistry';

const Chemistry = () => {
  return <TemplatePage data={chemistryData} />;
};

export default Chemistry;
